module.exports = __webpack_public_path__ + "img/logo.d6958d53.png";